/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AddUpdateOrderYieldModal_orderYieldEdges$ref: FragmentReference;
declare export opaque type AddUpdateOrderYieldModal_orderYieldEdges$fragmentType: AddUpdateOrderYieldModal_orderYieldEdges$ref;
export type AddUpdateOrderYieldModal_orderYieldEdges = $ReadOnlyArray<{|
  +node: {|
    +id: string,
    +item: {|
      +id: string
    |},
  |},
  +$refType: AddUpdateOrderYieldModal_orderYieldEdges$ref,
|}>;
export type AddUpdateOrderYieldModal_orderYieldEdges$data = AddUpdateOrderYieldModal_orderYieldEdges;
export type AddUpdateOrderYieldModal_orderYieldEdges$key = {
  +$data?: AddUpdateOrderYieldModal_orderYieldEdges$data,
  +$fragmentRefs: AddUpdateOrderYieldModal_orderYieldEdges$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "AddUpdateOrderYieldModal_orderYieldEdges",
  "type": "OrderYieldEdge",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "OrderYield",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "item",
          "storageKey": null,
          "args": null,
          "concreteType": "Item",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '199d88ea67d46f38e70ed2874e028600';
module.exports = node;
